import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('GpuExercise', 'v0');
export default exerciseTypeVersionAdapter;